import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from '../../../shared/config/config.service';
import { ContactAccountManager, ContactSupport } from '../models/support.model';

@Injectable()
export class SupportService {
  private config;

  constructor(
    private configService: ConfigService,
    private http: HttpClient) {
    this.config = this.configService.getConfig()!;
  }

  contactSupport(model: ContactSupport): Observable<void> {
    return this.http.post<void>(
      `${this.config.securityDepositBaseUrl}/manager/support/contact-support`, model);
  }

  contactAccountManager(model: ContactAccountManager): Observable<void> {
    return this.http.post<void>(
      `${this.config.securityDepositBaseUrl}/manager/support/contact-account-manager`, model);
  }
}
